import React, { useState } from "react";
import Modal from "../modals/Modal.tsx";
import InputField from "../Forms/InputField.js";
import toast from "react-hot-toast";
import { addServiceUserMedicationGroup } from "../../services/users.js";

export const CreateMedicationGroup = ({
  setOpenCreateGroupModal,
  openCreateGroupModal,
  userGroups,
  currentUserId,
  groupName,
  setGroupName,
  editGroup,
  reload,
  setEditGroup,
  editIndex,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [validationError, setValidationError] = useState("");

  // Check for duplicates in real-time
  const checkForDuplicate = (value) => {
    const normalizedValue = value.trim();

    if (!normalizedValue) {
      setValidationError("");
      return;
    }

    const isDuplicate = userGroups.some((group, index) => {
      // When editing, exclude the current group from duplicate check
      if (editGroup && editIndex !== null && index === editIndex) {
        return false;
      }
      return group.name.toLowerCase() === normalizedValue.toLowerCase();
    });

    if (isDuplicate) {
      setValidationError("A medication group with this name already exists");
    } else {
      setValidationError("");
    }
  };

  const handleGroupNameChange = (e) => {
    const value = e.target.value;
    setGroupName(value);
    checkForDuplicate(value);
  };
  const createGroup = async (e) => {
    e.preventDefault();

    // Trim whitespace and convert to lowercase for comparison
    const normalizedGroupName = groupName.trim();

    if (!normalizedGroupName) {
      toast.error("Group name cannot be empty");
      return;
    }

    // Check for duplicate names (case-insensitive)
    const isDuplicate = userGroups.some((group, index) => {
      // When editing, exclude the current group from duplicate check
      if (editGroup && editIndex !== null && index === editIndex) {
        return false;
      }
      return group.name.toLowerCase() === normalizedGroupName.toLowerCase();
    });

    if (isDuplicate) {
      toast.error("A medication group with this name already exists");
      return;
    }

    setIsLoading(true);

    if (editGroup && editIndex !== null) {
      const updatedGroups = [...userGroups];
      updatedGroups[editIndex].name = normalizedGroupName;
      setEditGroup(false);
      setGroupName("");
      setValidationError("");
      setOpenCreateGroupModal(false);
      toast.success("Medication group updated successfully");
      return;
    } else {
      try {
        const response = await addServiceUserMedicationGroup(currentUserId, {
          name: normalizedGroupName,
          serviceUserId: currentUserId,
        });
        console.log("medGrpCretd", response);
        reload();
        toast.success("Medication group created successfully");
        setOpenCreateGroupModal(false);
        setGroupName("");
        setValidationError("");
      } catch (error) {
        toast.error("Failed to create medication group");
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <Modal
      title={`${
        editGroup ? "Edit Medication Group" : "Create Medication Group"
      }`}
      size="md"
      onCancel={() => {
        setOpenCreateGroupModal(false);
        setGroupName("");
        setValidationError("");
      }}
      isOpen={openCreateGroupModal}
    >
      <form onSubmit={(e) => createGroup(e)}>
        <InputField
          name="groupName"
          label="Group Name"
          value={groupName}
          required
          onChange={handleGroupNameChange}
          error={validationError}
        />
        <button
          type="submit"
          className="btn btn__primary btn--block"
          disabled={isLoading || validationError}
        >
          {isLoading
            ? "Loading..."
            : editGroup && !isLoading
            ? "Update Group"
            : "Create Group"}
        </button>
      </form>
    </Modal>
  );
};
